import React from "react"
import withStyles from "react-jss"
import { Helmet, HelmetProvider } from "react-helmet-async"
import fonts from "./assets/fonts"
import globalStyles from "./data/globalStyles"
import { Page } from "./layouts"
import smoothscroll from "smoothscroll-polyfill"

const styles = {
  ...fonts,
  ...globalStyles,
}

// Safari doesn't support window.scrollTo smooth scrolling.
// Polyfill for that
smoothscroll.polyfill()

const App = () => {
  return (
    <HelmetProvider>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      <Page />
    </HelmetProvider>
  )
}

export default withStyles(styles)(App)
